import {
  Component,
  ContentChildren,
  Input,
  QueryList,
  ViewChild,
} from '@angular/core';
import { TabComponent } from './tab.component';
import { noAnimation } from './tabs.model';
import {
  TabComponent as SFTabComponent,
  TabModule,
} from '@syncfusion/ej2-angular-navigations';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sh-tabs',
  templateUrl: './tabs.component.html',
  styles: [
    `
      :host {display: block}
      .e-content {
        padding: 0.5rem 0.25rem;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, TabModule],
})
export class TabsComponent {
  @ViewChild(SFTabComponent) tabsRef?: SFTabComponent;
  @ContentChildren(TabComponent) tabs?: QueryList<TabComponent>;

  private _current: number | null = null;
  @Input() set current(value: number | null) {
    this._current = value;
    this.initTab();
  }

  animation = noAnimation;

  private initTab() {
    if (this._current != null) {
      this.tabsRef?.select(this._current);
    }
  }

  onCreated() {
    this.initTab();
  }
}
